import { DomSanitizer } from '@angular/platform-browser';
import { EmbedVideoService } from 'ngx-embed-video';
import { undefinedToNull } from '../utilities';

export class FirebaseMediaElementModel {

    file: File;
    fileName: string; //nombre del fichero en storage
    fileLocation: string;
    fileTitle: string; //titulo del media element
    url: string;
    urlsanitizer;
    text: string;
    type: string;
    videoType: string;
    intoStorage: boolean;


    constructor() {
        this.fileName = '';
        this.fileLocation = '';
        this.fileTitle = '';
        this.url = '';
        this.urlsanitizer = '';
        this.text = '';
        this.type = '';
        this.videoType = '';
        this.intoStorage = false;
    }

    toObject() {
        return Object.assign({}, this);
    }

    prepareMEObject() {
        var mediaElementObject = this.toObject();
        delete mediaElementObject.urlsanitizer;
        delete mediaElementObject.file;
        return mediaElementObject;
    }

    static objectMEtoModel(mediaElement) {
        var tourME = new FirebaseMediaElementModel();
        tourME.fileName = undefinedToNull(mediaElement.fileName);
        tourME.fileLocation = undefinedToNull(mediaElement.fileLocation);
        tourME.fileTitle = undefinedToNull(mediaElement.fileTitle);
        tourME.url = undefinedToNull(mediaElement.url);
        tourME.type = undefinedToNull(mediaElement.type);
        tourME.text = undefinedToNull(mediaElement.text);
        tourME.videoType = undefinedToNull(mediaElement.videoType);
        tourME.intoStorage = undefinedToNull(mediaElement.intoStorage);
        return tourME;
    }

    sanitizeUrl(sanitizer: DomSanitizer, embedService: EmbedVideoService) {
        if (this.type == 'audio' || this.type == 'video' || this.type == 'image') {
            if (this.type == 'video' && this.videoType == 'local')
                this.urlsanitizer = embedService.embed(this.url);
            else
                this.urlsanitizer = sanitizer.bypassSecurityTrustResourceUrl(this.url);
        }
    }


}